import { Controller } from 'stimulus';

class SearchResult extends Controller {
  connect() {
    $(this.contentTarget).on('show.bs.collapse', () => {
      $(this.element).addClass('is-open');
    });

    $(this.contentTarget).on('hide.bs.collapse', () => {
      $(this.element).removeClass('is-open');
    });
  }

  close() {
    $(this.contentTarget).collapse('hide');
  }
}

SearchResult.targets = [
  'content',
  'close',
];

export default SearchResult;
